<script setup lang="ts">
const props = defineProps({
  file: null,
  loading: { type: Boolean },
  error: null,
  label: null
})
const { state: myself } = useSelf()
const { copyFiles } = useJobs()

const copyFileTo = (dst: StaticFile, close: () => void) => {
  console.log("Copying file to:", dst)
  copyFiles({ [props.file.id]: props.file }, dst)
  close()
}
</script>

<template>
  <div class="agent-file-create-container">
    <slot />
    <div class="file-status">
      <div v-if="loading" class="left">
        <interface-spinner dots />
        <div>Loading</div>
      </div>
      <dropdown
        v-else-if="myself.home && file.isArtifact()"
        anchor-x="right"
        anchor-y="bottom"
        flow-x="left"
        flow-y="down"
      >
        <template #default="{ open }">
          <div class="left left-button" @click="open">
            <icon-action
              size="xs"
              type="save"
              class="save"
            />
            <div>Save</div>
          </div>
        </template>
        <template #menu="{ close }">
          <menu-file-picker
            :initial-folder="myself.home"
            folders-only
            class="save-file-picker"
            placeholder="Select a folder..."
            @select="dst => copyFileTo(dst, close)"
          />
        </template>
      </dropdown>
      <div v-if="!loading && !error" class="right">
        <icon-action
          size="xs"
          type="check"
          class="check"
        />
        <div>{{ label ?? 'Created file' }}</div>
      </div>
      <div v-else-if="error" class="right">
        <icon-action
          size="xs"
          type="cross"
          class="cross"
        />
        <div>Error encountered</div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.agent-file-create-container
  @apply w-full flex flex-col gap-2

.file-status
  @apply h-[22px] flex items-center t-menu-sm px-1
  .left, .right
    @apply flex items-center gap-1 text-[#{$global-t-tertiary}]
  .right
    @apply ml-auto
    .check
      @apply text-[#{$global-green-primary}]
    .cross
      @apply text-[#{$global-red-primary}]
  .left-button:hover
    @apply -mx-1 px-1 -my-0.5 py-0.5 rounded-[6px] bg-$global-steel-secondary text-white cursor-pointer

.save-file-picker
  @apply mt-2
</style>
